import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loadmore',
  templateUrl: './loadmore.component.html',
  styleUrls: ['./loadmore.component.scss']
})
export class LoadmoreComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
